import React from "react";

import type { Impulse } from "~/tools/impulse";

import type { TimelineSummaryRequestWithTimeRange } from "../../../queries/timeline";

export interface TimelineSummaryRequestContextValue {
	request: undefined | TimelineSummaryRequestWithTimeRange;
	refreshCount: number;
}

export const TimelineSummaryRequestContext = React.createContext<null | Impulse<TimelineSummaryRequestContextValue>>(
	null,
);
